// contact-form.component.ts

import { Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { QeleoIconComponent } from "../../components/qeleo-icon/qeleo-icon.component";
import { firstValueFrom } from "rxjs";
import {ToastService} from "../../../core/services/toast.service";

@Component({
  selector: "app-contact-form",
  templateUrl: "./contact-form.component.html",
  styleUrl: "./contact-form.component.scss",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    QeleoIconComponent
  ],
})
export class ContactFormComponent {
  activeModal = inject(NgbActiveModal);
  toastService = inject(ToastService);
  contactForm: FormGroup;
  submitted = false;

  constructor(private fb: FormBuilder, private http: HttpClient) {
    this.contactForm = this.fb.group({
      fullname: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      "field[1]": [""],
      "field[5]": ["", Validators.required],
      u: ["11"],
      f: ["11"],
      s: [""],
      c: ["0"],
      m: ["0"],
      act: ["sub"],
      v: ["2"],
      or: ["79767c8c809fa209339fe57283adf6f8"],
      jsonp: ["true"],
    });
  }

  onSubmit() {
    if (this.contactForm.valid) {
      this.submitForm();
    }
  }

  async submitForm() {
    this.submitted = true;
    try {
      const formData = new FormData();
      Object.keys(this.contactForm.value).forEach((key) => {
        formData.append(key, this.contactForm.value[key]);
      });

      await firstValueFrom<any>(
        this.http.post("https://qeleo.activehosted.com/proc.php", formData, {
          responseType: "text",
        })
      );

      this.submitted = false;
      this.toastService.show({text: 'Form Submitted Successfully.', classname: 'success-toast', delay: 3000});
      this.activeModal.dismiss();
    } catch (error: any) {
      console.error("Error submitting form", error);
      this.submitted = false;
    }
  }
}

